import EFPicture from '@elem/compCommon/EFPicture';
import { getSubscribeNumber, submitScribe } from '@elem/Service/delta-pro-ultra';
import Close from '@elem/SVGIcon/DeltaProUltra/Close';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { getPagesPrivacyPolicy } from '@/utils/common';

let animationId: any = null;
const duration = 4000; // 动画持续时间（毫秒）
let initAniTime = 0; // 开启动画的时间
let aniFrameTime = 0; // 每一帧动画进入时间
let pause = false; // 用户交互鼠标移入是否暂停
let percent = 0; // 进度
let replay = false; // 暂停后继续播放
let enterTime = 0; // 鼠标移入时间
let leaveTime = 0; // 鼠标移出时间
export default function A({ callback, buyLink }: any) {
    const { useLang, useRouter, useState, useEffect, Link, gtm } = useGlobal();
    const { t } = useLang('delta_pro_ultra.prelaunch');
    const { locale } = useRouter();
    const [input, setInput] = useState('');
    const [inputVal, setInputVal] = useState('');
    const [check, setCheck] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [showMsg, setShowMsg] = useState('');
    const LOCAL_SITES: string[] = ['jp'];

    const swipers: any[] = [
        {
            img: '1',
            subtitle: t('secA_subtitle'),
            title: t.rich('secA_title', {
                n: (text: string) => <span className="no-wrap">{text}</span>,
            }),
            launch: t('secA_launch'),
        },
        {
            img: '1_2',
            subtitle: t('secA_subtitle_2'),
            title: t.rich('secA_title_2', {
                n: (text: string) => <span className="no-wrap">{text}</span>,
            }),
            launch: t('secA_launch_2'),
            note: t('secA_note_2'),
        },
    ];

    const [swiper, setSwiper] = useState<any>({});

    // 轮播变化埋点
    const slideChangeHandle = (index: number) => {
        const item = swipers[index - 1];
        if (item) {
            gtm.push({
                event: 'uaEvent',
                event_name: 'view_banner',
                banner_name: item.title,
                position: `carousel banner_${index}}`,
                nonInteraction: false,
            });
        }
        initAniTime = 0;
        if (animationId) {
            cancelAnimationFrame(animationId);
            animationId = null;
        }
        doAnimate();
    };

    const hanldleMouseEnter = () => {
        if (swiper) {
            pause = true;
            replay = false;
            enterTime = new Date().getTime();
            if (animationId) {
                cancelAnimationFrame(animationId);
            }
        }
    };

    const hanldleMouseLeave = () => {
        if (swiper) {
            pause = false;
            replay = true;
            leaveTime = new Date().getTime();
            doAnimate();
        }
    };

    // 执行动画的函数
    const animate = (_currentTime: number) => {
        if (!initAniTime) {
            initAniTime = new Date().getTime();
        }
        aniFrameTime = new Date().getTime();
        const element = document.querySelector(
            `.delta-pro-ultra-A .banner-swiper .swiper-pagination .swiper-pagination-bullet-active .after`,
        ) as HTMLSpanElement;

        // 计算动画进度（0 到 1 之间的值）
        if (element && swiper) {
            if (!pause) {
                if (replay) {
                    initAniTime = initAniTime + (leaveTime - enterTime);
                    leaveTime = 0;
                    enterTime = 0;
                    replay = false;
                }
                const judgeTime = aniFrameTime - initAniTime;
                const progress = Math.min(judgeTime / duration, 1);
                percent = progress;
                element.style.transform = `translateX(-${100 - 100 * percent}%)`;
                if (judgeTime >= duration) {
                    try {
                        swiper && swiper.slideNext && swiper.slideNext();
                    } catch (e: any) {}
                }
            } else {
                element.style.transform = `translateX(-${100 - 100 * percent}%)`;
            }
            requestAnimationFrame(animate);
        }
    };

    const doAnimate = () => {
        if (animationId) cancelAnimationFrame(animationId);
        animationId = requestAnimationFrame(animate);
    };

    const handleInputChange = (v: any) => {
        setInput(v.target.value);
        setInputVal(v.target.value);
    };

    const handleCheck = () => {
        setCheck(!check);
        if (!check && showMsg) {
            setShowMsg('');
        }
        if (check && !showMsg) {
            setShowMsg(t('common_agree_tip'));
        }
    };

    const handleSubmit = async () => {
        const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
        if (!input.trim()) {
            return setShowMsg(t('common_email_tip_null'));
        }
        if (!emailRegex.test(input.trim())) {
            return setShowMsg(t('common_email_tip_format'));
        }
        if (!check) {
            return setShowMsg(t('common_agree_tip'));
        }
        try {
            const data =
                locale === 'jp'
                    ? {
                          email: input.trim(),
                          contactListId: '743933504',
                          fields: [
                              {
                                  id: '4431',
                                  type: 'single',
                                  value: 1,
                                  overwrite: true,
                              },
                              {
                                  id: '31',
                                  type: 'single',
                                  value: 1,
                                  overwrite: true,
                              },
                              {
                                  id: '9157',
                                  type: 'multiple',
                                  value: [1],
                                  overwrite: false,
                              },
                          ],
                      }
                    : { email: input.trim() };
            const res = await submitScribe(locale, data, {
                sector_name: `DPU_${t('secA_subtitle')}`,
                entry_position: '1',
            });
            if (res?.code === '0') {
                setShowModal(!LOCAL_SITES.includes(locale));
                setInput('');
                setShowMsg(LOCAL_SITES.includes(locale) ? t('common_submit_success') : '');
                if (LOCAL_SITES.includes(locale)) {
                    setTimeout(() => {
                        setShowMsg('');
                    }, 2500);
                }
                if (!LOCAL_SITES.includes(locale)) {
                    try {
                        const res = await getSubscribeNumber(locale);
                        if (res?.code !== '0') {
                            console.error(res?.message);
                        } else {
                            callback(res?.data);
                        }
                    } catch (e) {
                        console.error(e);
                    }
                }
                try {
                    gtm.push({
                        event: 'uaEvent',
                        event_name: 'activity_submit',
                        button_name: t('common_btn'),
                        status: 'success',
                        tag: 'Agree',
                    });
                } catch (e) {
                    console.error(e);
                }
            } else {
                setShowMsg(res?.message);
                console.error(res?.message);
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'activity_submit',
                    button_name: t('common_btn'),
                    status: 'fail',
                    tag: 'Agree',
                });
            }
        } catch (e) {
            console.error(e);
            gtm.push({
                event: 'uaEvent',
                event_name: 'activity_submit',
                button_name: t('common_btn'),
                status: 'fail',
                tag: 'Agree',
            });
        } finally {
            if (window?.fbq) {
                // @ts-ignore
                window?.fbq('track', 'Lead');
                // @ts-ignore
                window?.fbq('track', 'Search');
            }
        }
    };

    const handleJoin = async () => {
        try {
            const res = await submitJoin(locale, { email: inputVal.trim() });
            if (res?.code !== '0') {
                console.log(res?.message);
            }
        } catch (e) {
            console.error(e);
        } finally {
            try {
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'activity_button',
                    page_name: t('secA_title'),
                    list_name: 'Join us for insider access, exclusive benefits, and tips and tricks. Be a part of EcoFlow and power your business growth',
                    button_name: t('common_modal_btn'),
                    function: 'Join Community',
                });
            } catch (e) {
                console.error(e);
            }
            return true;
        }
    };

    const handleToEmail = () => {
        const target = document.querySelector('.delta-pro-ultra-C') as HTMLElement;
        window.scrollTo({
            top: target.offsetTop,
            behavior: 'smooth',
        });
        try {
            gtm.push({
                event: 'uaEvent',
                event_name: 'floating_button',
                button_name: 'Buy Now',
            });
        } catch (e) {
            console.error(e);
        }
    };

    useEffect(() => {
        if (typeof window !== 'undefined' && swiper && !LOCAL_SITES.includes(locale)) {
            // 启动动画
            doAnimate();
        }
    }, [swiper, locale]);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const eles: any = document.querySelectorAll(`.delta-pro-ultra-A .banner-swiper .swiper-pagination .swiper-pagination-bullet`);
            for (let i = 0; i < eles?.length; i++) {
                const existedSpan = eles[i].querySelector('.after') as HTMLSpanElement;
                if (!existedSpan) {
                    const span = document.createElement('span');
                    span.setAttribute('class', 'after');
                    eles[i].appendChild(span);
                }
            }
        }
    }, []);

    return (
        <div id="delta-pro-ultra-prelaunch-A" className={`delta-pro-ultra-A ${css['delta-pro-ultra-A']}`}>
            {LOCAL_SITES.includes(locale) && (
                <div className="banner-img">
                    <EFPicture
                        src={`/responsive/picture/delta-pro-ultra/prelaunch/1${LOCAL_SITES?.includes(locale) ? `_${locale}` : ''}.jpg`}
                        srcPad={`/responsive/picture/delta-pro-ultra/prelaunch/1_768${LOCAL_SITES?.includes(locale) ? `_${locale}` : ''}.jpg`}
                        srcMobile={`/responsive/picture/delta-pro-ultra/prelaunch/1_375${LOCAL_SITES?.includes(locale) ? `_${locale}` : ''}.jpg`}
                        alt={t('secA_title')}
                    />
                    <div className="banner-box">
                        <p className="banner-subtitle">{t('secA_subtitle')}</p>
                        <p className="banner-title">
                            {t.rich('secA_title', {
                                n: (text: string) => <span className="no-wrap">{text}</span>,
                            })}
                        </p>
                        <p className="banner-launch">{t('secA_launch')}</p>
                        {locale !== 'jp' && (
                            <a href="#delta-pro-ultra-prelaunch-C" className="coupoun-img">
                                <EFPicture
                                    src={'/responsive/picture/delta-pro-ultra/prelaunch/1_1.png'}
                                    srcDesktop={'/responsive/picture/delta-pro-ultra/prelaunch/1_1_1366.png'}
                                    srcPad={'/responsive/picture/delta-pro-ultra/prelaunch/1_1_768.png'}
                                    srcMobile={'/responsive/picture/delta-pro-ultra/prelaunch/1_1_768.png'}
                                    alt={t('secA_title')}
                                />
                            </a>
                        )}
                        {locale === 'jp' && (
                            <>
                                <div className="control">
                                    <input type="text" className="input" value={input} onChange={handleInputChange} placeholder={t('common_placeholder')} />
                                    <button className="subscribe" onClick={handleSubmit}>
                                        {t('common_btn')}
                                    </button>
                                </div>
                                {showMsg && <p className="error-msg">{showMsg}</p>}
                                <div className="agreement">
                                    <input type="checkbox" className="agree-check" id="agree" checked={check} onChange={handleCheck} />
                                    <label htmlFor="agree" className="agree-label">
                                        {t.rich('common_agree', {
                                            a1: (text: string) => (
                                                <Link
                                                    className="link"
                                                    href={
                                                        locale === 'jp'
                                                            ? 'https://account.ecoflow.com/agreement/ja-jp/TermsOfUse.html'
                                                            : `https://${locale}.ecoflow.com/pages/terms-of-use`
                                                    }
                                                >
                                                    {text}
                                                </Link>
                                            ),
                                            a2: (text: string) => (
                                                <Link
                                                    className="link"
                                                    href={
                                                        locale === 'jp'
                                                            ? 'https://account.ecoflow.com/agreement/ja-jp/PrivacyPolicy.html'
                                                            : getPagesPrivacyPolicy(locale)
                                                    }
                                                >
                                                    {text}
                                                </Link>
                                            ),
                                        })}
                                    </label>
                                </div>
                            </>
                        )}
                    </div>
                    {LOCAL_SITES.includes(locale) && <p className="note">{t('secA_note')}</p>}
                    {!LOCAL_SITES.includes(locale) && (
                        <div className="coupoun-icon" onClick={handleToEmail}>
                            <EFPicture src={'/responsive/picture/delta-pro-ultra/prelaunch/1.png'} alt={t('secA_title')} />
                            <p className="icon-text">{t('secA_coupon_text')}</p>
                            <p className="icon-btn">{t('secA_coupon_btn')}</p>
                        </div>
                    )}
                </div>
            )}

            {!LOCAL_SITES.includes(locale) && (
                <Swiper
                    className="banner-swiper"
                    modules={[Navigation, Pagination]}
                    navigation={true}
                    pagination={true}
                    spaceBetween={0}
                    loop={true}
                    // centeredSlides={true}
                    slidesPerView={'auto'}
                    initialSlide={0}
                    onSlideChange={(swiper) => slideChangeHandle(swiper.activeIndex)}
                    onSwiper={(swiperIns: any) => setSwiper(swiperIns)}
                >
                    {swipers?.map((item: any, k: number) => (
                        <SwiperSlide className="swiper-item" key={k} onMouseEnter={hanldleMouseEnter} onMouseLeave={hanldleMouseLeave}>
                            <div className="banner-img">
                                <EFPicture
                                    src={`/responsive/picture/delta-pro-ultra/prelaunch/${item?.img}.jpg`}
                                    srcPad={`/responsive/picture/delta-pro-ultra/prelaunch/${item?.img}_768.jpg`}
                                    srcMobile={`/responsive/picture/delta-pro-ultra/prelaunch/${item?.img}_375.jpg`}
                                    alt={item?.title}
                                />
                                <div className="banner-box">
                                    <p className="banner-subtitle">{item?.subtitle}</p>
                                    <p className="banner-title">{item?.title}</p>
                                    <p className="banner-launch">{item?.launch}</p>
                                    <a href="#delta-pro-ultra-prelaunch-C" className="coupoun-img">
                                        <EFPicture
                                            src={'/responsive/picture/delta-pro-ultra/prelaunch/1_1.png'}
                                            srcDesktop={'/responsive/picture/delta-pro-ultra/prelaunch/1_1_1366.png'}
                                            srcPad={'/responsive/picture/delta-pro-ultra/prelaunch/1_1_768.png'}
                                            srcMobile={'/responsive/picture/delta-pro-ultra/prelaunch/1_1_768.png'}
                                            alt={t('secA_title')}
                                        />
                                    </a>
                                    {item?.note && <p className="banner-note h5">{item?.note}</p>}
                                </div>
                                {item?.note && <p className="banner-note pc">{item?.note}</p>}
                                <div className="coupoun-icon" onClick={handleToEmail}>
                                    <EFPicture src={'/responsive/picture/delta-pro-ultra/prelaunch/1.png'} alt={t('secA_title')} />
                                    <p className="icon-text">{t('secA_coupon_text')}</p>
                                    <p className="icon-btn">{t('secA_coupon_btn')}</p>
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            )}

            <div className={`modal ${showModal ? 'show' : ''}`}>
                <div className="modal-content">
                    <Close className="close" onClick={() => setShowModal(false)} />
                    <p className="modal-title">{t.rich('common_modal_title')}</p>
                    <p className="modal-text">
                        {t.rich('common_modal_text', {
                            n: (text: string) => <span className="no-wrap">{text}</span>,
                        })}
                    </p>
                    <a href={buyLink} className="modal-btn" target="_blank" onClick={handleJoin} rel="noreferrer">
                        {t('common_modal_btn')}
                    </a>
                </div>
            </div>
            <div className="cover"></div>
        </div>
    );
}
